export default "__VITE_ASSET__DteWQpnn__"